import clsx from 'clsx';
import { type ButtonHTMLAttributes, cloneElement, type SVGProps, type JSX } from 'react';

import type { ButtonSizeVariants } from '../button';

type IconProps = {
  icon?: JSX.Element;
  className?: JSX.Element['props']['className'];
  size?: ButtonSizeVariants['size'];
  onClick?: ButtonHTMLAttributes<HTMLButtonElement>['onClick'];
};

export const Icon = ({
  icon,
  className,
  size = 'default',
  onClick,
}: IconProps) => {
  if (!icon) {
    return null;
  }

  const props = icon.props as SVGProps<SVGSVGElement>;

  return cloneElement(icon, {
    width: size === 'sm' ? 20 : 24,
    height: size === 'sm' ? 20 : 24,
    ...props,
    className: clsx([className, props.className]),
    onClick,
  });
};

Icon.displayName = 'Icon';
